import { add, partialRight, nth, equals, pipe, when, complement } from 'ramda';

import { fork, getIn, isDefined } from 'utils/ramda';

export const checkPageDevide = ({ items, height, maxHeight, currentItemIndex }) => {
  const getItemByIndex = partialRight(nth, [items]);
  const isNextPageTitleSame = fork(
    equals,
    pipe(getItemByIndex, getIn('pageTitle')),
    pipe(add(1), getItemByIndex, when(isDefined, getIn('pageTitle'))),
  );

  const isNextBlockExist = pipe(add(1), getItemByIndex, isDefined);
  const isNextBlockNotExist = complement(isNextBlockExist);

  if (isNextBlockNotExist(currentItemIndex)) return false;
  if (isNextPageTitleSame(currentItemIndex)) return false;

  return height / maxHeight > 0.55;
};
